import { dataMember, required, anyArray, typedArray } from 'santee-dcts';
import { SponsorStudySite } from './sponsor-study-site';

export class SponsorStudySitesReadModel {
    @dataMember()
    @required()
    @typedArray(SponsorStudySite)
    public sites: SponsorStudySite[];
}
